<template>
  <div class="block" v-if="project != null && laboral_reference != null">

    <div class="feedback-task-validations row" v-if="message != ''">
      <div class="col-sm-12">
        <div class="alert alert-success" role="alert">
          {{message}}
          <a :href="href" target="_blank" v-if="href != ''">Link Whatsapp</a>
        </div>
      </div>
    </div>

    <div class="info-laboral row-gw">
      <h2>Crear / Editar referencias laborales</h2>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label">
          ¿Autoriza contactar esta referencia?
        </label>
      </div>
      <div class="col-sm-9">
        <input type="checkbox" id="authorize_contact" v-model="laboral_reference.authorize_contact"/>
        <span class="help-block">Marque esta casilla si el candidato autoriza contactar a la referencia</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label">
          ¿La referencia se niega calificar cuantitativamente el desempeño del aspirante?
        </label>
      </div>
      <div class="col-sm-9">
        <input type="checkbox" id="reference_not_qualify" v-model="laboral_reference.reference_not_qualify">
        <span class="help-block">Marque esta casilla si la referencia se niega a calificar cuantitativamente el desempeño del aspirante</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">Empresa:*</label>
      </div>
      <div class="col-sm-9">
        <input type="text" class="form-control" v-model="laboral_reference.company_name">
        <span class="help-block">Ingrese el nombre de la empresa</span>
      </div>
    </div>

    <div class="row row-gw row-alert">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">Tipo de relación:* (Asegurese de elegir la opción CORRECTA)</label>
      </div>
      <div class="col-sm-9">
        <select v-model="laboral_reference.relation_type" class="form-control">
          <option v-for="relation in type_relations" :key="relation.id" :value="relation.id">{{relation.name}}</option>
        </select>
        <span class="help-block" v-if="laboral_reference.relation_type != null && laboral_reference.id != null">{{laboral_reference.relation_type | descriptionRole }}</span>
        <span class="help-block" v-else>Ingrese el tipo de relación laboral</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">Cargo desempeñado:*</label>
      </div>
      <div class="col-sm-9">
        <input type="text" class="form-control" v-model="laboral_reference.charge">
        <span class="help-block">Ingrese el cargo desempeñado en la empresa</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">Fecha inicial:*</label>
      </div>
      <div class="col-sm-9">
        <input type="date" class="form-control" v-model="laboral_reference.start_at">
        <span class="help-block">Ingrese la fecha de inicio en la empresa</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label">
          Actualmente trabajo acá
        </label>
      </div>
      <div class="col-sm-9">
        <input type="checkbox" id="reference_not_qualify" v-model="laboral_reference.current_work">
        <span class="help-block">Marque esta casilla si la referencia actualmente trabaja acá</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">Fecha final:*</label>
      </div>
      <div class="col-sm-9">
        <input type="date" class="form-control" v-model="laboral_reference.leave_at">
        <span class="help-block">Ingrese la fecha de finalización en la empresa</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">Nombre contacto:*</label>
      </div>
      <div class="col-sm-9">
        <input type="text" class="form-control" v-model="laboral_reference.contact_name">
        <span class="help-block">Ingrese el nombre del contacto en la empresa</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">Cargo contacto:*</label>
      </div>
      <div class="col-sm-9">
        <input type="text" class="form-control" v-model="laboral_reference.contact_charge">
        <span class="help-block">Ingrese el cargo del contacto en la empresa</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">Email contacto:*</label>
      </div>
      <div class="col-sm-9">
        <input type="email" class="form-control" v-model="laboral_reference.email">
        <span class="help-block">Ingrese el email del contacto en la empresa</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">Teléfono contacto:*</label>
      </div>
      <div class="col-sm-9">
        <input type="text" class="form-control" v-model="laboral_reference.contact_telephone">
        <span class="help-block">Ingrese el teléfono del contacto en la empresa</span>
      </div>
    </div>

    <div class="info-laboral row-gw">
      <h2>CAMPOS OPCIONALES (SE DIGITARAN EN CASO DE QUE LA REFERENCIA NO RESPONDA POR EMAIL O SMS)</h2>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">Última asignación salarial:*</label>
      </div>
      <div class="col-sm-9">
        <input type="email" class="form-control" v-model="laboral_reference.salary">
        <span class="help-block">Ingrese el último salario percibido en la empresa</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">Tipo de contrato:*</label>
      </div>
      <div class="col-sm-9">
        <select v-model="laboral_reference.contract" class="form-control">
          <option v-for="contract in contracts" :key="contract.id" :value="contract.id">{{contract.name}}</option>
        </select>
        <span class="help-block">Ingrese el tipo de contrato</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">Llamados de atención:*</label>
      </div>
      <div class="col-sm-9">
        <input type="number" class="form-control" v-model="laboral_reference.calls">
        <span class="help-block">Ingrese la cantidad de llamados de atención recibidos</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">Motivo de retiro:*</label>
      </div>
      <div class="col-sm-9">
        <input type="text" class="form-control" v-model="laboral_reference.retirement">
        <span class="help-block">Ingrese el motivo de retiro de la empresa</span>
      </div>
    </div>

    <div class="row row-gw">

      <div class="col-sm-3">
        <label class="control-label" for="company_name">Observaciones:*</label>
      </div>

      <div class="col-sm-9">
        <div class="col-sm-5">
          <textarea type="text" class="form-control" rows="10" cols="10" v-model="laboral_reference.observations"></textarea>
          <small class="template-text-laboral">La Señora XXXXXX, indica que el aspirante se caracterizó en el tiempo que estuvo en la compañía por su XXXXX,XXXXX, YYYY, ZZZZZ . Así mismo, afirma que en una valoración de 1 a 5, le brindaría un X en la gestión desarrollada en la empresa y si tuviera la oportunidad de contratarlo de nuevo, XX lo volvería a hacer</small>
        </div>

          <div class="col-md-2 align-self-center">
            <button id="improve-text-laboral" class="btn btn-info" type="button" style="width: 100%;" :disabled="disabeGPT" @click.prevent="callServiceChat()">
              <span v-if="spinner" class="spinner-border"></span>
              <span v-else>Transformar</span>
            </button>
          </div>

        <div class="col-sm-5">
          <textarea type="text" class="form-control" rows="10" cols="10" readonly=true v-model="this.observations_ia"></textarea>
          <small class="template-text-laboral">Texto mejorado usando IA</small>
        </div>
      </div>

      <div class="col-sm-3"></div>

      <div class="col-sm-9">
        <div class="col-md-5">
          <div class="custom-control custom-radio">
          <input type="radio" id="obs_by_analist_laboral" value="obs_by_analist" class="custom-control-input no-resize" v-model="selected_obs_with_ia">
            <label class="custom-control-label">Usar texto original</label>
          </div>
        </div>

        <div class="col-md-2"></div>

        <div class="col-md-5">
          <div class="custom-control custom-radio">
          <input type="radio" id="obs_by_ia_laboral" value="obs_by_ia" class="custom-control-input no-resize" v-model="selected_obs_with_ia">
            <label class="custom-control-label">Usar texto recomendado por IA</label>
          </div>
        </div>
      </div>


    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label">
          ¿Referencia verificada?
        </label>
      </div>
      <div class="col-sm-9">
        <input type="checkbox" id="verified_reference" v-model="laboral_reference.verified_reference"/>
        <span class="help-block">Marque esta casilla si la referencia esta verificada</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label">
          ¿Contactar por email y SMS y Whatsapp?
        </label>
      </div>
      <div class="col-sm-9">
        <input type="checkbox" id="contact_by_email" v-model="laboral_reference.contact_by_email"/>
        <span class="help-block">Marque esta casilla si desea intentar contactar la referencia por email y SMS y Whatsapp</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label">
          ¿Email respondido?
        </label>
      </div>
      <div class="col-sm-9">
        <input type="checkbox" id="email_answered" v-model="laboral_reference.email_answered" disabled/>
        <span class="help-block">Si esta casilla esta marcada es debido a que la referencia ya respondio por medio de un link enviado al correo electrónico</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">De 1 a 5, ¿cómo califica el desempeño laboral del referenciado? Donde 5 es bueno y 1 es malo:*</label>
      </div>
      <div class="col-sm-9">
        <input type="number" class="form-control" v-model="laboral_reference.qualification" min="0" max="5">
        <span class="help-block">Este campo no debe ser gestionado*</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">¿Que cualidades puede destacar del referenciado (Maximo 3)?</label>
      </div>
      <div class="col-sm-9">
        <input type="text" class="form-control" rows="10" cols="10" v-model="laboral_reference.personality">
        <span class="help-block">Este campo no debe ser gestionado*</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">¿Volvería a contratarlo?</label>
      </div>
      <div class="col-sm-9">
        <input type="text" class="form-control" rows="10" cols="10" v-model="laboral_reference.description">
        <span class="help-block">Este campo no debe ser gestionado*</span>
      </div>
    </div>

    <div class="row row-gw">
      <div class="col-sm-3">
        <label class="control-label" for="company_name">Última asignación salarial:</label>
      </div>
      <div class="col-sm-9">
        <input type="text" class="form-control" rows="10" cols="10" v-model="laboral_reference.salary">
        <span class="help-block">Este campo no debe ser gestionado*</span>
      </div>
    </div>

    <div class="feedback-task-validations row" v-if="message != ''">
      <div class="col-sm-12">
        <div class="alert alert-success" role="alert">
          {{message}}
          <a :href="href" target="_blank" v-if="href != ''">Link Whatsapp</a>
        </div>
      </div>
    </div>

    <div class="laboral-references-actions">
      <button class="btn btn-success button-laboral" @click.prevent="save">Guardar referencia</button>
      <button class="btn btn-danger button-laboral" @click.prevent="restoreLaboralReference">Limpiar Formulario</button>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      href: '',
      type_relations: [
        { id: 0, name: 'Jefe Inmediato o superior'},
        { id: 1, name: 'Colaborador'}
      ],
      contracts: [
        { id: 0, name: 'Indefinido'},
        { id: 1, name: 'Fijo'},
        { id: 2, name: 'Obra labor'},
        { id: 3, name: 'Prestación de servicios'},
        { id: 4, name: 'Otro'},
        { id: 5, name: 'Freelancer'},
        { id: 6, name: 'Aprendiz'},
        { id: 7, name: 'Practicante'}
      ],
      message: '',
      observations_ia: '',
      spinner: false,
      selected_obs_with_ia: 'obs_by_analist',
      disabeGPT: true
    }
  },
  computed: {
    ...mapGetters(["project", "laboral_reference"]),
  },
  watch: {
    'laboral_reference.observations'(value){
      if(value !== ''){
        this.disabeGPT = false
      } else {
        this.disabeGPT = true
      }
    }
  },
  methods: {
    ...mapMutations(['changeProject', 'changeLaboralReference']),
    setCredentials (){
      axios.defaults.headers['x-csrf-token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
    save () {
      this.setCredentials()
      if (this.laboral_reference.id == null) {
        this.laboral_reference.project_id = this.project.id
        this.create()
      } else {
        this.update()
        // debug create
        // delete this.laboral_reference.id
        // this.create()
      }
    },
    async create () {
      this.laboral_reference.request_validation = true
      const request = await axios.post('/api/v1/laboral', { laboral_reference: this.laboral_reference, observations_ia: this.observations_ia, selected_obs_with_ia: this.selected_obs_with_ia }, {})
      this.processRequest(request, 'create')
    },
    async update () {
      const request = await axios.put(`/api/v1/laboral/${this.laboral_reference.id}`, { laboral_reference: this.laboral_reference, observations_ia: this.observations_ia, selected_obs_with_ia: this.selected_obs_with_ia }, {})
      this.processRequest(request, 'update')
    },
    async callServiceChat () {
      this.spinner = true
      let reques = await axios.get(`/artificial_grammar?text=${this.laboral_reference.observations}`).then(res=>{
        console.log(res)
        if (res.status == 200 || res.status == 201) {
          this.observations_ia = res.data.data
          this.disabeGPT = true
          this.selected_obs_with_ia = 'obs_by_analist'
        } else {
          console.log('Error')
          this.disabeGPT = false
        }
			})
      this.spinner = false
    },
    processRequest (request, origin) {
      if (request.status == 200 || request.status == 201) {
        if (origin == 'create') {
          this.message = 'Registro guardado'
        } else {
          this.message = 'Registro actualizado'
        }
        console.log(request)
        this.href = request.data.url_whatsapp
        this.changeProject(request.data.project)
        this.restoreLaboralReference()
        this.disabeGPT = true
        setTimeout(() => this.message = '', 30000);
      }
      this.observations_ia = ''
      this.selected_obs_with_ia = 'obs_by_analist'
    },
    restoreLaboralReference () {
      this.changeLaboralReference({})
    }
  },
  filters: {
    descriptionRole: function(value) {
      if (value == 'boss') {
        return 'Jefe inmediato o superior'
      } else {
        return 'Colaborador'
      }
    }
  }
};
</script>

<style scoped>
  @keyframes spinner-border {
    to { transform: rotate(360deg); }
  }

  .spinner-border {
    position: relative;
    display: inline-block;
    width: 1.2rem;
    height: 1.2rem;
    overflow: hidden;
    text-indent: -999em;
    border: .2em solid;
    border-color: currentColor transparent currentColor currentColor;
    border-radius: 50%;
    animation-name: spinner-border;
    animation-duration: .7s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }

  .no-resize{
    resize: none;
  }
</style>
